import { useMemo } from 'react'
import { IconVerified } from '../../../../shared/components/icons/IconVerified'
import { Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'
import { NonCompliantAffiliate } from '../../../../app/api'
import { Popover } from '../../../../lib/ui/popover/component/Popover'

export const AdvertiserCell = ({ advertisers }: NonCompliantAffiliate) => {
  const { t } = useTranslation()
  const advertiser = useMemo(() => {
    if (!advertisers.length) return null

    return advertisers.reduce((max, current) =>
      (current.ads_count ?? 0) > (max.ads_count ?? 0) ? current : max,
    )
  }, [advertisers])

  return (
    <div>
      {advertiser ? (
        <div>
          <div className={'flex gap-[4px]'}>
            <Tooltip title={advertiser?.name}>
              <p className={'max-w-[170px] truncate'}>{advertiser?.name}</p>
            </Tooltip>
            {advertiser.verified && (
              <Tooltip
                title={t('pages.paidResults.tooltipVerifiedByFallback', {
                  name: advertiser.verified_by,
                })}
              >
                <span>
                  <IconVerified className='ml-1 mb-1 inline w-[16px]' color='#00BD7B' />
                </span>
              </Tooltip>
            )}
          </div>
          {!!(advertisers.length - 1) && (
            <Popover
              trigger={() => (
                <span
                  className={
                    'cursor-pointer border-b border-dotted text-[13px] leading-[13px] text-focus'
                  }
                >
                  {t('pages.paidResults.showMore', {
                    count: advertisers.length - 1,
                  })}
                </span>
              )}
            >
              <ul className={'w-[272px] list-disc pl-[14px]'}>
                {advertisers.map((advertiser, index) => (
                  <li key={index} className={'text-[14px]'}>
                    {advertiser.name}{' '}
                    {advertiser.verified && (
                      <Tooltip
                        title={t('pages.paidResults.tooltipVerifiedByFallback', {
                          name: advertiser.verified_by,
                        })}
                      >
                        <span>
                          <IconVerified className='ml-1 inline w-[16px]' color='#00BD7B' />
                        </span>
                      </Tooltip>
                    )}
                  </li>
                ))}
              </ul>
            </Popover>
          )}
        </div>
      ) : (
        <Tooltip title={t('pages.paidResults.notAvailableTooltip')}>
          <span>N/A</span>
        </Tooltip>
      )}
    </div>
  )
}
